/**
 * Admin "my procedure is not listed" leads (M12-T04 + M14-T13). amtc_admin only.
 * The PATCH (M14-T13) is what finally makes these leads actionable.
 */
import { apiFetch, type CappedList } from './client'

export type AdminProcedureLead = {
  id: string
  reference: string
  description: string
  area: string | null
  patient_name: string | null
  patient_phone: string | null
  status: string
  concierge_notes: string | null
  created_at: string
}

export const PROCEDURE_LEADS_KEY = ['admin', 'procedure-requests'] as const

/** GET /api/v1/admin/procedure-requests — newest first, optional ?status=. */
export async function fetchProcedureLeads(
  token: string | null,
  status?: string | null,
  q?: string,
): Promise<CappedList<AdminProcedureLead>> {
  const params = new URLSearchParams()
  if (status) params.set('status', status)
  if (q) params.set('q', q)
  const qs = params.toString() ? `?${params.toString()}` : ''
  return await apiFetch<CappedList<AdminProcedureLead>>(
    `/api/v1/admin/procedure-requests${qs}`,
    { token },
  )
}

/** PATCH /api/v1/admin/procedure-requests/{ref} — set status + notes. */
export async function updateProcedureLead(
  token: string | null,
  reference: string,
  input: { status: string; concierge_notes?: string },
): Promise<void> {
  await apiFetch(`/api/v1/admin/procedure-requests/${reference}`, {
    method: 'PATCH',
    token,
    body: {
      status: input.status,
      ...(input.concierge_notes !== undefined
        ? { concierge_notes: input.concierge_notes }
        : {}),
    },
  })
}
